(() => {
  const quickAddSelector = '.product-card-quick-add, .category-product-quick-add';
  let lastFocusedElement = null;

  const drawer = () => document.querySelector('[data-cart-drawer]');
  const overlay = () => document.querySelector('[data-cart-drawer-overlay]');

  function formatMoney(cents, currency) {
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: currency || 'EUR'
    }).format(Number(cents || 0) / 100);
  }

  function setDrawerOpen(open) {
    const panel = drawer();
    const backdrop = overlay();
    if (!panel || !backdrop) return;

    if (open) {
      lastFocusedElement = document.activeElement;
      panel.hidden = false;
      backdrop.hidden = false;
      requestAnimationFrame(() => {
        panel.classList.add('is-open');
        backdrop.classList.add('is-open');
      });
      document.body.classList.add('infuzze-cart-drawer-open');
      panel.querySelector('[data-cart-drawer-close]')?.focus();
      return;
    }

    panel.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    document.body.classList.remove('infuzze-cart-drawer-open');
    window.setTimeout(() => {
      panel.hidden = true;
      backdrop.hidden = true;
    }, 330);
    lastFocusedElement?.focus?.();
  }

  function updateHeaderCount(count) {
    document.querySelectorAll('.cart').forEach(link => {
      const badge = link.querySelector('b');
      if (badge) badge.textContent = count;
      link.setAttribute('aria-label', `Panier, ${count} article(s)`);
    });
  }

  function cartItemElement(item, currency) {
    const article = document.createElement('article');
    article.className = 'infuzze-cart-drawer-item';

    const imageUrl = item.image || item.featured_image?.url || '';
    if (imageUrl) {
      const imageLink = document.createElement('a');
      imageLink.href = item.url || '#';
      const image = document.createElement('img');
      image.src = imageUrl;
      image.alt = item.product_title || '';
      image.loading = 'lazy';
      imageLink.appendChild(image);
      article.appendChild(imageLink);
    } else {
      article.classList.add('has-no-image');
    }

    const details = document.createElement('div');
    const title = document.createElement('strong');
    const titleLink = document.createElement('a');
    titleLink.href = item.url || '#';
    titleLink.textContent = item.product_title || item.title || 'Produit';
    title.appendChild(titleLink);
    details.appendChild(title);

    if (item.variant_title && item.variant_title !== 'Default Title') {
      const variant = document.createElement('small');
      variant.textContent = item.variant_title;
      details.appendChild(variant);
    }

    const quantity = document.createElement('span');
    quantity.textContent = `Quantité : ${item.quantity}`;
    details.appendChild(quantity);
    article.appendChild(details);

    const price = document.createElement('b');
    price.textContent = formatMoney(item.final_line_price, currency);
    article.appendChild(price);
    return article;
  }

  function renderCartItems(cart, panel, currency) {
    const list = panel.querySelector('[data-cart-drawer-items]');
    if (!list) return;
    list.replaceChildren(...cart.items.map(item => cartItemElement(item, currency)));
  }

  function updateDrawer(item, cart) {
    const panel = drawer();
    if (!panel) return;
    const currency = panel.dataset.currency || 'EUR';
    const variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    panel.querySelector('[data-cart-drawer-added-product]').textContent = `${item.product_title || item.title || 'Produit'}${variantTitle ? ` · ${variantTitle}` : ''}`;
    panel.querySelector('[data-cart-drawer-count]').textContent = cart.item_count;
    panel.querySelector('[data-cart-drawer-count-heading]').textContent = cart.item_count;
    panel.querySelector('[data-cart-drawer-total]').textContent = formatMoney(cart.total_price, currency);
    window.InfuzzeCartRewards.update(panel, cart);
    renderCartItems(cart, panel, currency);

    updateHeaderCount(cart.item_count);
  }

  async function addFromCard(form) {
    const panel = drawer();
    if (!panel) {
      window.alert('Le panier rapide est momentanément indisponible. Recharge la page puis réessaie.');
      return;
    }

    const button = form.querySelector('button[type="submit"]');
    const originalHtml = button?.innerHTML || '';
    const formData = new FormData(form);
    const root = panel.dataset.rootUrl || window.Shopify?.routes?.root || '/';

    if (button) {
      button.disabled = true;
      button.classList.add('is-loading');
      button.textContent = 'Ajout…';
    }

    try {
      const addResponse = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      });
      if (!addResponse.ok) throw new Error('add_failed');
      const item = await addResponse.json();
      const cartResponse = await fetch(`${root}cart.js`, { headers: { 'Accept': 'application/json' } });
      if (!cartResponse.ok) throw new Error('cart_failed');
      const cart = await cartResponse.json();
      updateDrawer(item, cart);
      setDrawerOpen(true);
    } catch (error) {
      window.alert('Impossible d’ajouter cette recette pour le moment. Réessaie dans quelques instants.');
    } finally {
      if (button) {
        button.disabled = false;
        button.classList.remove('is-loading');
        button.innerHTML = originalHtml;
      }
    }
  }

  document.addEventListener('submit', event => {
    const form = event.target.closest?.(quickAddSelector);
    if (!form) return;
    event.preventDefault();
    addFromCard(form);
  });

  document.addEventListener('click', event => {
    if (event.target.closest('[data-cart-drawer-close]') || event.target.matches('[data-cart-drawer-overlay]')) {
      setDrawerOpen(false);
    }
  });

  document.addEventListener('keydown', event => {
    const panel = drawer();
    if (event.key === 'Escape' && panel?.classList.contains('is-open')) setDrawerOpen(false);
  });
})();
